var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',[_c('UgoForm',{attrs:{"form":_vm.form},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }